export default __webpack_public_path__ + "static/media/complementary--including-bicycles-and-motorcycles--g1.ee870326.png";